import { useState } from "react";
import ReactSwitch from "react-switch";
import DatePicker from "react-datepicker";
import styles from "../../styles/_sections/_coupon/addCoupon.module.scss";

const AddCoupon = () => {
  const [checked, setChecked] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  return (
    <div className={styles.container}>
      <div className={styles.fields}>
        <input type="text" placeholder="Discount" name="discountPercentage" />
        <input type="text" placeholder="Code" name="couponCode" />
        <button>Add Coupon</button>
      </div>

      <div className={styles.validity}>
        <div className={styles.switch}>
          <h2>Validity:</h2>
          <ReactSwitch
            onChange={() => setChecked(!checked)}
            checked={checked}
            checkedIcon={false}
            uncheckedIcon={false}
          />
        </div>
        {checked && (
          <div className={styles.dates}>
            <div className={styles.field}>
              <label>From</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
            </div>
            <div className={styles.field}>
              <label>To</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddCoupon;
